import React, { useEffect}  from 'react';
import '../App.css';
import HeroSection from '../containers/Hero/MainHeroSection';
import Services from '../containers/Services/ServiceSection';
import BioPreview from '../containers/BioPreview/BioPreviewSection';
import ProjectsPage from './Projects';
import Footer from '../containers/Footer/Footer';




function Home() {

    useEffect(() => {

        // const previousOverflow = document.body.style.overflow;
    
        // Disable scrolling
        // document.body.style.overflow = 'hidden';
    
        return () => {
          // Re-enable scrolling when the component is unmounted
          // document.body.style.overflow = previousOverflow;
        };
      }, []);
    
      return (
        <>
          <HeroSection />
          <Services />
          <BioPreview />
          <ProjectsPage />
          <Footer />
        </>
        
      );
    }

export default Home;




